var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5.625C1.25 4.44625 1.25 3.8575 1.61625 3.49125C1.9825 3.125 2.57125 3.125 3.75 3.125H11.25C12.4288 3.125 13.0175 3.125 13.3837 3.49125C13.75 3.8575 13.75 4.44625 13.75 5.625C13.75 5.91937 13.75 6.06687 13.6588 6.15875C13.5669 6.25 13.4187 6.25 13.125 6.25H1.875C1.58062 6.25 1.43312 6.25 1.34125 6.15875C1.25 6.06687 1.25 5.91875 1.25 5.625ZM1.25 11.25C1.25 12.4288 1.25 13.0175 1.61625 13.3837C1.9825 13.75 2.57125 13.75 3.75 13.75H11.25C12.4288 13.75 13.0175 13.75 13.3837 13.3837C13.75 13.0175 13.75 12.4288 13.75 11.25V8.125C13.75 7.83063 13.75 7.68313 13.6588 7.59125C13.5669 7.5 13.4187 7.5 13.125 7.5H1.875C1.58062 7.5 1.43312 7.5 1.34125 7.59125C1.25 7.68313 1.25 7.83125 1.25 8.125V11.25Z",
    fill: "#C7C8CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 1.875V3.75M10.625 1.875V3.75",
    stroke: "#C7C8CD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateFill);
export default __webpack_public_path__ + "static/media/date-fill.c4497af96aa2a5c9f700506aa4a32f8c.svg";
export { ForwardRef as ReactComponent };